import React, { useEffect, useState } from 'react'
import './index.scss'
import { connect } from 'react-redux'
import Filterbutton from '../../reusableComponents/filterbutton/filterbutton'
import { countNonEmptyKeysExcluding } from '../../reusableComponents/commonFunctions/commonFunctions'

export const SelectedFilterOptions = (props) => {
  let [countFilter, setCountFilter] = useState(0)
  let removeFilterOption = (option) => {
    console.log(option)
  }
  const excludeKeys = ["StateAbbreviation", "Species", "HuntTypeKey", "unitName", "DrawChoice"];
  useEffect(() => {
    if (props.huntplannerMorefiltersState) {
      const count = countNonEmptyKeysExcluding(props.huntplannerMorefiltersState, excludeKeys);
      setCountFilter(count)
    }
  }, [props.huntplannerMorefiltersState])

  return (
    <>
      {countFilter > 0 &&
        <div className="selected-filters-on-map-container">
          {Object.entries(props.huntplannerMorefiltersState || {})
            .filter(([key]) => !excludeKeys.includes(key)) // Exclude specific keys
            .map(([key, value]) =>
              value ? (
                <Filterbutton
                  key={key}
                  header={key}
                  value={value}
                  removeFilterOption={() => removeFilterOption(key, value)}
                />
              ) : null
            )}
        </div>
      }
    </>
  )
}

const mapStateToProps = state => ({
  huntPlannerSelectedOtions: state.huntPlannerSelectedOtions,
  huntplannerMorefiltersState: state.huntplannerMorefilters,
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(SelectedFilterOptions)
